import React, { useEffect } from 'react';
import { Input, Checkbox, Select, Tooltip } from 'antd';
import { useFormDataContext } from '../../contexts/form-data.ctx';
import Text from 'antd/lib/typography/Text';
import { Box } from '../../../../components/Box';
import uuid from 'react-uuid';
import { countries } from '../../../editor/countries/countries';
import { Option } from '../../../../components/Input';
import { translations } from '../../../../utils/LocalizedStrings';
import { Icon } from 'semantic-ui-react';

function NumberOfOwnersComponent({ documentId, name, label = 'Select', ...rest }) {
  const values = useFormDataContext(({ data, setField }) => ({
    value: data[name] || {},
    setField,
  }));

  const [fieldValues, setFieldValues] = React.useState(values);
  const [, updateState] = React.useState({});

  const handleChange = async () => {
    await values.setField({
      target: {
        name,
        value: fieldValues.value,
      },
    });
  };

  const changeValue = (e) => {
    if (!fieldValues.value[documentId]) {
      fieldValues.value[documentId] = {};
    }
    let valuesCopy = JSON.parse(JSON.stringify(fieldValues));
    valuesCopy.value[documentId].amount = e.target.value;
    setFieldValues(valuesCopy);
  };

  return (
    <>
      {fieldValues && fieldValues.value && (
        <>
          <Box flex={1} id='numberOfPropertyOwnersContainer'>
            <p className='inputLabelTooltip'>
              <Text strong>{translations.artifacts.numberOfPropertyOwners.numberOfPropertyOwnersText}</Text>
              <Tooltip title={translations.artifacts.numberOfPropertyOwners.numberOfOwnersTooltip}>
                <span className="icon-info">
                  <Icon name="info circle" />
                </span>
              </Tooltip>
            </p>
            <Input
              min={0}
              max={100}
              id={'numberOfOwners' + documentId}
              type="number"
              name="share"
              onBlur={handleChange}
              onChange={changeValue}
              value={
                fieldValues.value[documentId]
                  ? fieldValues.value[documentId].amount
                  : ''
              }
            />
          </Box>
        </>
      )}
    </>
  );
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Mutator: NumberOfOwnersComponent,
};
